import React from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';

import { useTimeModal } from '../../TimeModal/TimeModalContext';
import { formatDate, normalizeDate } from '../../../Utils/GlobalUtils';

import Loading from '../../Loading';
import WarningPanel from '../../WarningPanel';

import styles from '../../../styles/DynamicModal.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as XIcon } from '../../../icons/x-close.svg';
import { ReactComponent as CheckCircleIcon } from '../../../icons/check-circle.svg';
import { ReactComponent as XCircleIcon } from '../../../icons/x-circle.svg';
import { ReactComponent as PenIcon } from '../../../icons/pen.svg';
import { ReactComponent as ArrowUpIcon } from '../../../icons/caret-up.svg';
import { ReactComponent as ArrowDownIcon } from '../../../icons/caret-down.svg';

export default function ConfirmAppointment({ closeModal, caseInfo, AM, action, onSuccess }) {
    const navigate = useNavigate();
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState({
        number: caseInfo.number,
        date_court: caseInfo.date_court ?? '',
        date_am_appointment_m: caseInfo.date_am_appointment_m ?? '',
        date_am_appointment_r: caseInfo.date_am_appointment_r ?? '',
        status_am_appointment_approval: 'Подтверждено',
        is_charge_fee: '1',
    });
    const [isAdditionalFeeOperations, setIsAdditionalFeeOperations] = React.useState(false);
    const [amountFee, setAmountFee] = React.useState('');
    const [additionalComment, setAdditionalComment] = React.useState('');
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));

        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (!formInfo.number) {
            newErrors.number = 'Обязательное поле';
        }
        if (!formInfo.date_court) {
            newErrors.date_court = 'Обязательное поле';
        }
        if (!formInfo.date_am_appointment_m) {
            newErrors.date_am_appointment_m = 'Обязательное поле';
        }
        if (!formInfo.date_am_appointment_r) {
            newErrors.date_am_appointment_r = 'Обязательное поле';
        }
    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const confirmAppointmentData = () => {
        const token = localStorage.getItem('token');

        axios.put('/api/confirm-appointment', {
            case_id: caseInfo.id,
            number: formInfo.number,
            date_court: normalizeDate(formInfo.date_court),
            date_am_appointment_m: normalizeDate(formInfo.date_am_appointment_m),
            date_am_appointment_r: normalizeDate(formInfo.date_am_appointment_r),
            status_am_appointment_approval: formInfo.status_am_appointment_approval,
            is_charge_fee: formInfo.is_charge_fee,
            amount_fee: amountFee,
            additional_comment: additionalComment
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(() => {
            openTimeModal('Назначение подтверждено СРО', 'success');
            onSuccess();
            closeModal();
        })
        .catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    };

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            confirmAppointmentData();
        } else {
            setIsEditFields(true);
        }
        setLoading(false);
    };

    React.useEffect(() => {
        if (formInfo.status_am_appointment_approval=='Не подтверждено' && formInfo.is_charge_fee=='1') {
            setFormInfo((prev) => ({
                ...prev,
                is_charge_fee: '0',
            }));
        }
    }, [formInfo.status_am_appointment_approval, formInfo.is_charge_fee]);

    React.useEffect(() => {
        if (isAdditionalFeeOperations && formInfo.is_charge_fee == '0') {
            setIsAdditionalFeeOperations(false);
        }
    }, [isAdditionalFeeOperations, formInfo.is_charge_fee])

    const [isEditFields, setIsEditFields] = React.useState(false);


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>
                        {action=='confirm' && 'Подтверждение назначения управляющего'} 
                        {action=='view' && 'Просмотр информации по подтверждению назначения'}
                    </h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    {action=='confirm' ?
                    <>
                    <span
                        className='horizontalContainer'
                        style={{alignItems: 'start'}}
                    >
                        <h3 className='formHeadline'>Проверьте данные</h3>
                        <button
                            type='button'
                            className='miniButton'
                            style={{width: 'fit-content'}}
                            onClick={() => setIsEditFields(!isEditFields)}
                        >
                            <IconContainer 
                                Icon={!isEditFields ? PenIcon : XIcon} 
                                isClickable={false}
                                size = '14' 
                                color = 'black' 
                                className = '' 
                            />
                            Изменить
                        </button>
                    </span>
                    <div className='labelInputWrapper'>
                        <a className='label'>Номер дела</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                    type='text' 
                                    value={formInfo.number} 
                                    onChange={handleChange('number')} 
                                    className={errorsForm.number ? 'inputError' : ''}
                                    placeholder='' 
                                    minLength='' 
                                    maxLength='' 
                                    disabled={loading || !isEditFields}
                                    required 
                                />
                                {errorsForm.number && <div className='errorUnderInput'>{errorsForm.number}</div>}
                            </div>
                        </div>
                    </div>

                    <div className='labelInputWrapper'>
                        <a className='label'>Дата судебного заседания об утверждении АУ</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                    type='date' 
                                    value={formInfo.date_court?.split('T')[0]} 
                                    onChange={handleChange('date_court')} 
                                    className={errorsForm.date_court ? 'inputError' : ''}
                                    placeholder='' 
                                    minLength='' 
                                    maxLength='' 
                                    disabled={loading || !isEditFields}
                                    required 
                                />
                                {errorsForm.date_court && <div className='errorUnderInput'>{errorsForm.date_court}</div>}
                            </div>
                        </div>
                    </div>
                    
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата утверждения управляющего АС</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                    type='date' 
                                    value={formInfo.date_am_appointment_m?.split('T')[0]} 
                                    onChange={handleChange('date_am_appointment_m')} 
                                    className={errorsForm.date_am_appointment_m ? 'inputError' : ''}
                                    placeholder='' 
                                    minLength='' 
                                    maxLength='' 
                                    disabled={loading || !isEditFields}
                                    required 
                                />
                                <p className='description'>Полная версия</p>
                                {errorsForm.date_am_appointment_m && <div className='errorUnderInput'>{errorsForm.date_am_appointment_m}</div>}
                            </div>
                            <div className='inputWrapper'>
                                <input 
                                    type='date' 
                                    value={formInfo.date_am_appointment_r?.split('T')[0]} 
                                    onChange={handleChange('date_am_appointment_r')} 
                                    className={errorsForm.date_am_appointment_r ? 'inputError' : ''}
                                    placeholder='' 
                                    minLength='' 
                                    maxLength='' 
                                    disabled={loading || !isEditFields}
                                    required 
                                />
                                <p className='description'>Резолютивная часть</p>
                                {errorsForm.date_am_appointment_r && <div className='errorUnderInput'>{errorsForm.date_am_appointment_r}</div>}
                            </div>
                        </div>
                    </div>

                    <span className='horizontalLine'></span>

                    <div className='labelInputWrapper'>
                        <a className='label'>Управляющий</a>
                        <div className='labelInputRight'>
                            <div
                                className='panel'
                            >
                                <Link
                                    className='aWithLink'
                                    to={`/account/${caseInfo.user_id}`}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    {AM.lastname}
                                    &nbsp;
                                    {AM.firstname}
                                    &nbsp;
                                    {AM.surname}
                                    &nbsp;
                                    (Открыть в новой вкладке)
                                </Link>
                                <a
                                    className='aWithLink'
                                    href={`mailto:${AM.email}`}
                                >
                                    {AM.email}
                                </a>
                                <a
                                    className='description'
                                >
                                    Выбран СРО: {formatDate(caseInfo.date_candidate_selection)}
                                </a>
                            </div>
                            <div
                                className='panel'
                            >
                                <span
                                    className='horizontalContainer'
                                >
                                    <a>Списать у управляющего плату за утверждение</a>
                                    <div className='checkboxWrapper'>
                                        <label className='switch' htmlFor='is_charge_fee'>
                                            <input 
                                                type='checkbox'
                                                id='is_charge_fee'
                                                checked={formInfo.is_charge_fee === '1'} 
                                                onChange={(e) => {
                                                    setFormInfo((prev) => ({
                                                        ...prev,
                                                        is_charge_fee: e.target.checked ? '1' : '0',
                                                    }))
                                                }}
                                            />
                                            <div className='slider round'></div>
                                        </label>
                                    </div>
                                </span>
                                <span className='horizontalLine'></span>
                                <span
                                    className='horizontalContainer'
                                >
                                    <a>Подтверждаю назначение</a>
                                    <div className='checkboxWrapper'>
                                        <label className='switch' htmlFor='status_am_appointment_approval'>
                                            <input 
                                                type='checkbox'
                                                id='status_am_appointment_approval'
                                                checked={formInfo.status_am_appointment_approval === 'Подтверждено'} 
                                                onChange={(e) => {
                                                    setFormInfo((prev) => ({
                                                        ...prev,
                                                        status_am_appointment_approval: e.target.checked ? 'Подтверждено' : 'Не подтверждено',
                                                    }))
                                                }}
                                            />
                                            <div className='slider round'></div>
                                        </label>
                                    </div>
                                </span>
                                <span
                                    className='horizontalContainer'
                                    style={formInfo.is_charge_fee === '1' ? {} : {opacity: '.3'}}
                                >
                                    <a>Установить другую сумму списания за назначение</a>
                                    <IconContainer 
                                        Icon={isAdditionalFeeOperations ? ArrowUpIcon : ArrowDownIcon} 
                                        isClickable={true}
                                        onClick={() => {
                                            if (!isAdditionalFeeOperations) {
                                                setFormInfo((prev) => ({
                                                    ...prev,
                                                    is_charge_fee: '1',
                                                }));
                                            };

                                            setIsAdditionalFeeOperations(!isAdditionalFeeOperations);
                                        }}
                                        size = '16' 
                                        color = {'black'} 
                                        className = '' 
                                    />
                                </span>
                                {isAdditionalFeeOperations &&
                                <>
                                    <div className='labelInputWrapper'>
                                        <a className='label'>Сумма списания</a>
                                        <div className='labelInputRight'>
                                            <div className='inputWrapper'>
                                                <input 
                                                    type='text' 
                                                    value={amountFee} 
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d*$/.test(value)) {
                                                        setAmountFee(value);
                                                        }
                                                    }}
                                                    maxLength='7' 
                                                    placeholder='Сумма' 
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='labelInputWrapper'>
                                        <a className='label'>Дополнительное описание к операции списания</a>
                                        <div className='labelInputRight'>
                                            <div className='inputWrapper'>
                                                <input 
                                                    type='text' 
                                                    value={additionalComment} 
                                                    onChange={(e) => setAdditionalComment(e.target.value)} 
                                                    placeholder='' 
                                                    minLength='' 
                                                    maxLength='300' 
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>
                        </div>
                    </div>
                    <WarningPanel text={<p>Статус карточки будет автоматически переведен на "В работе (Управляющий назначен)".<br/>Обязательно проверьте, что все данные соответствуют действительности и указаны корректно. Отменить подтверждение будет невозможно</p>} type={'warning'} />
                    </>
                    :
                    <>
                    <div className='labelInputWrapper'>
                        <a className='label'>Статус</a>
                        <div className='labelInputRight'>
                            <span className='horizontalContainer'>
                                <a>Назначение {caseInfo.status_am_appointment_approval.toLowerCase()}</a>
                                <IconContainer 
                                    Icon={caseInfo.status_am_appointment_approval=='Подтверждено' ? CheckCircleIcon : XCircleIcon} 
                                    isClickable={false}
                                    size = '20' 
                                    color = {caseInfo.status_am_appointment_approval=='Подтверждено' ? 'green' : 'red'} 
                                    className = '' 
                                />
                            </span>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата подтверждения</a>
                        <div className='labelInputRight'>
                            <a>{formatDate(caseInfo.date_am_appointment_approval)}</a>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Инициатор</a>
                        <div className='labelInputRight'>
                            <div
                                className='panel'
                            >
                                <Link
                                    className='aWithLink'
                                    to={`/account/${caseInfo.am_appointment_approver_id}`}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    {caseInfo.approval_user?.lastname}
                                    &nbsp;
                                    {caseInfo.approval_user?.firstname}
                                    &nbsp;
                                    {caseInfo.approval_user?.surname}
                                    &nbsp;
                                    (Открыть в новой вкладке)
                                </Link>
                                <a
                                    className='aWithLink'
                                    href={`mailto:${caseInfo.approval_user?.email}`}
                                >
                                    {caseInfo.approval_user?.email}
                                </a>
                            </div>
                        </div>
                    </div>
                    </>}
                </div>
                <div className={styles.bottom}>
                    {action=='confirm' &&
                    <>
                    <div>{status}</div>
                    <button 
                        type='button' 
                        className='button' 
                        onClick={handleSave}
                    >
                        Отправить
                    </button>
                    </>}
                </div>
            </div>
        </div>
    )
}
